<template>
	<div class="row mb-3">
		<div class="col-3 col-sm-4">
			<!-- desktop -->
			<div class="d-none d-md-block body-strong text-grey-900 text-start">
				{{ content.planner_resumeTotal }}
			</div>
			<!-- mobile -->
			<div class="d-block d-md-none body-strong text-grey-900 text-start">
				{{ content.planner_resumeTotal }}
			</div>
		</div>
		<div
			class="col-9 col-sm-8 d-flex flex-column-reverse flex-md-row flex-nowrap justify-content-end justify-content-sm-between"
		>
			<ParticipantsTotals
				:participants="participants"
				:content="content"
				:additionalClasses="'justify-content-end body-strong text-grey-900'"
			/>
			<div class="d-flex flex-row flex-nowrap justify-content-end">
				<Prices
					:isLoading="pricesLoadingSet.has(currentCacheKey)"
					:crossedPrice="totals.crossedPrice"
					:totalPrice="totals.totalPrice"
					:perPrice="totals.perPrice"
					:maxPromo="totals.maxPromo"
					:locale="locale"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import Prices from "@/vue/planning/components/common/prices.vue";
import ParticipantsTotals from "@/vue/planning/components/common/participantsTotals.vue";
import { mapState, mapGetters } from "vuex";
import store from "@/vue/planning/store/store";
import pricesLoadingSet from "@/vue/planning/state/pricesLoadingSet";
import currentCacheKey from "@/vue/planning/computed/currentCacheKey";

export default {
	store,
	name: "Total",
	data() {
		return {
			pricesLoadingSet,
			currentCacheKey,
		};
	},
	computed: {
		...mapState(["participants", "content"]),
		...mapGetters(["totals", "locale"]),
	},
	components: {
		Prices,
		ParticipantsTotals,
	},
};
</script>

<style scoped></style>
